import { Component, Input } from '@angular/core';
import { DecimalPipe, NgForOf, NgIf, SlicePipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-mb-data-summary',
  standalone: true,
  imports: [NgForOf, DecimalPipe, NgIf, TranslocoDirective, SlicePipe],
  templateUrl: './mb-data-summary.component.html',
})
export class MbDataSummaryComponent {
  @Input() title = '';
  @Input() imgSrc = '';
  @Input() data: { name: string; value: number }[] | null = [];
  @Input() valueLabel = 'Cases';
}
